import axios from "axios";
import { API_BASE_URL } from "../config/apiConfig";


// Verificar si un estudiante tiene acceso a sus boletines
export const verificarAccesoEstudiante = async (studentId) => {
  const token = localStorage.getItem("authToken");
  const headers = { Authorization: `${token}` };
  const response = await axios.get(
    `${API_BASE_URL}/boletin-visibilidad/verificar/${studentId}`,
    { headers }
  );
  return response.data;
};

// Verificar si un estudiante tiene acceso a un periodo específico
export const verificarAccesoPeriodo = async (studentId, periodoId) => {
  const token = localStorage.getItem("authToken");
  const headers = { Authorization: `${token}` };
  const response = await axios.get(
    `${API_BASE_URL}/boletin-visibilidad/verificar/${studentId}/${periodoId}`,
    { headers }
  );
  return response.data;
};

// Obtener lista de inhabilitaciones activas
export const getInhabilitados = async () => {
  const token = localStorage.getItem("authToken");
  const headers = { Authorization: `${token}` };
  const response = await axios.get(
    `${API_BASE_URL}/boletin-visibilidad/inhabilitados`,
    { headers }
  );
  return response.data;
};

// Gestionar visibilidad (habilitar/inhabilitar)
export const gestionarVisibilidad = async (data) => {
  const token = localStorage.getItem("authToken");
  const headers = { Authorization: `${token}` };
  const response = await axios.post(
    `${API_BASE_URL}/boletin-visibilidad/gestionar`,
    data,
    { headers }
  );
  return response.data;
};

export const getAllBoletines = async () => {
  const token = localStorage.getItem("authToken");
  const headers = { Authorization: `${token}` };
  const response = await axios.get(`${API_BASE_URL}/boletin`, { headers });
  return response.data.data;
};

export const getBoletinesByDirector = async () => {
  const token = localStorage.getItem("authToken");
  const headers = {
    Authorization: `${token}`,
  };
  const response = await axios.get(`${API_BASE_URL}/boletin/director`, {
    headers,
  });
  return response.data.data;
};

export const createBoletin = async (data) => {
  const token = localStorage.getItem("authToken");
  const headers = {
    Authorization: `${token}`,
  };
  const response = await axios.post(`${API_BASE_URL}/boletin`, data, {
    headers,
  });
  return response.data;
};

export const updateBoletin = async (data) => {
  const token = localStorage.getItem("authToken");
  const headers = {
    Authorization: `${token}`,
  };
  const response = await axios.put(`${API_BASE_URL}/boletin`, data, {
    headers,
  });
  return response.data;
};

export const getBoletinPDF = async (studentId, periodoId, grado) => {
  const token = localStorage.getItem("authToken");
  const headers = {
    Authorization: `${token}`,
  };
  const nivel = ["parvulos", "prejardin", "jardin", "transicion"].includes(
    grado?.toLowerCase()
  )
    ? "preescolar"
    : "primaria";

  const response = await axios.get(
    `${API_BASE_URL}/boletin/${nivel}/${studentId}/${periodoId}`,
    {
      headers,
    }
  );

  return response.data;
};

export const getObservacion = async (studentId, periodoId) => {
  const token = localStorage.getItem("authToken");
  const headers = {
    Authorization: `${token}`,
  };
  const response = await axios.get(
    `${API_BASE_URL}/observaciones/${studentId}/${periodoId}`,
    {
      headers,
    }
  );
  return response.data.data;
};

export const deleteBoletin = async (students_id, periodo_id) => {
  const token = localStorage.getItem("authToken");
  const headers = { Authorization: `${token}` };
  const response = await axios.delete(
    `${API_BASE_URL}/boletin/${students_id}/${periodo_id}`,
    { headers }
  );
  return response.data;
};


// BOLETÍN FINAL

// Generar boletín final de un estudiante específico
export const generarBoletinFinal = async (studentId) => {
  const token = localStorage.getItem("authToken");
  const headers = { Authorization: `${token}` };
  const response = await axios.post(
    `${API_BASE_URL}/boletin/generar-final/${studentId}`,
    {},
    { headers }
  );
  return response.data;
};

// Generar boletines finales de todo un salón
export const generarBoletinesFinalesPorSalon = async (salonId) => {
  const token = localStorage.getItem("authToken");
  const headers = { Authorization: `${token}` };
  const response = await axios.post(
    `${API_BASE_URL}/boletin/generar-finales-salon/${salonId}`,
    {},
    { headers }
  );
  return response.data;
};

// Obtener estudiantes de un salón con sus boletines finales
export const getEstudiantesSalonConBoletines = async (salonId) => {
  const token = localStorage.getItem("authToken");
  const headers = { Authorization: `${token}` };
  const response = await axios.get(
    `${API_BASE_URL}/boletin/estudiantes-salon-finales/${salonId}`,
    { headers }
  );
  return response.data.data;
};

// Función para obtener boletín final específico
export const getBoletinFinal = async (studentId) => {
  const token = localStorage.getItem("authToken");
  const headers = { Authorization: `${token}` };
  try {
    const response = await axios.post(`/api/boletin/final/${studentId}`, { headers });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Error al obtener boletín final');
  }
};

export const generarPuestosPeriodoService = async (periodoId) => {
  const token = localStorage.getItem("authToken");
  const headers = { Authorization: `${token}` };
  const response = await axios.post(
    `${API_BASE_URL}/boletin/generar-puestos/${periodoId}`,
    {},
    { headers }
  );
  return response.data;
};

// 🆕 Validar si un estudiante tiene todas las notas
export const validarNotasEstudiante = async (studentId, periodoId) => {
  const token = localStorage.getItem("authToken");
  const headers = { Authorization: `${token}` };
  const response = await axios.get(
    `${API_BASE_URL}/boletin/validar-notas/${studentId}/${periodoId}`,
    { headers }
  );
  return response.data;
};

// 🆕 Validar si todos los estudiantes de un salón tienen notas
export const validarNotasSalon = async (periodoId) => {
  const token = localStorage.getItem("authToken");
  const headers = { Authorization: `${token}` };
  const response = await axios.get(
    `${API_BASE_URL}/boletin/validar-notas-salon/${periodoId}`,
    { headers }
  );
  return response.data;
};